import {createAsyncThunk} from '@reduxjs/toolkit';
import {metaDataService} from '../service/meta-data-service';
import {AxiosResultStatus} from '../../shared/service/axios-result-status';
import {patientHelper} from '../../patient/services/patient-service';

export const getMetaData = createAsyncThunk(
    "metaData/getMetaData",
    async (param: void, thunkAPI) => {

    const response = await Promise.all([
        metaDataService.getPatientEncounterMetaData(),
        metaDataService.getPaymentChannels(),
        metaDataService.getPatientMetadata(),
        metaDataService.getPaymentsV3Metadata()
    ])

    response.forEach((metaDataResponse:Awaited<AxiosResultStatus>) => {
       if(metaDataResponse.hasErrors){
           patientHelper.robustErrorHandler(metaDataResponse, thunkAPI);
       }
    })

    const [patientEncounterMetaData, paymentChannelMetaData, patientMetadata, paymentsV3Metadata] = response;

    return{
        ...patientEncounterMetaData.entity,
        ...patientMetadata.entity,
        paymentChannel: paymentChannelMetaData.entity,
        ...paymentsV3Metadata.entity
    }
    }
)

export const getAlerts = createAsyncThunk("metaData/getAlerts", async (clientId: number | string, thunkAPI) => {
    const alerts = await metaDataService.getAlerts(clientId);
    return {
        clientId,
        alerts
    }
})

export const getEmployers = createAsyncThunk("metaData/getEmployers", async (clientId: number | string, thunkAPI) => {
    const employers = await metaDataService.getEmployers(clientId);
    return {
        clientId,
        employers
    }
})

export const createEmployer = createAsyncThunk("metaData/createEmployer", async ({clientId, employerName}: {clientId: number, employerName: string}, thunkAPI) => {
    const response = await metaDataService.createEmployer({clientId, employerName});
    if(response.hasErrors){
        patientHelper.robustErrorHandler(response, thunkAPI);
    }else{
        return {
            clientId,
            employer: response.entity
        }
    }
})

export const patchClientAlert = createAsyncThunk(
    "metaData/patchClientAlert",
    async ({ clientId, clientAlertId, note_body }: { clientId: number; clientAlertId: number; note_body: string }, thunkAPI) => {
        const response = await metaDataService.patchClientAlert({ clientId, clientAlertId, note_body });
        if (response.hasErrors) {
            patientHelper.robustErrorHandler(response, thunkAPI);
        } else {
            return { clientId, updatedAlert: response.entity };
        }
    }
)

export const createClientAlert = createAsyncThunk(
    "metaData/createClientAlert",
    async ({ clientId, alert_type_id, note_body, alert_ref_id, prefix, group_code }: {
        clientId: number;
        alert_type_id: number;
        note_body: string;
        alert_ref_id?: string;
        prefix?: string;
        group_code?: string;
    }, thunkAPI) => {
        const response = await metaDataService.createClientAlert({ clientId, alert_type_id, note_body, alert_ref_id, prefix, group_code });
        if (response.hasErrors) {
            patientHelper.robustErrorHandler(response, thunkAPI);
        } else {
            return { clientId, newAlert: response.entity };
        }
    }
)

export const deleteClientAlert = createAsyncThunk(
    "metaData/deleteClientAlert",
    async ({ clientId, clientAlertId }: { clientId: number; clientAlertId: number }, thunkAPI) => {
        const response = await metaDataService.deleteClientAlert({ clientId, clientAlertId });
        if (response.hasErrors) {
            patientHelper.robustErrorHandler(response, thunkAPI);
        } else {
            return { clientId, clientAlertId };
        }
    }
)